<script setup>
import { computed } from 'vue';

const props = defineProps({
    frequencies: { type: Float32Array, default: () => new Float32Array(72) },
});

const generatePath = (frequencies) => {
    const points = 4; // Increased number of points for more irregularity
    const angleStep = (Math.PI * 2) / points;
    const center = { x: 250, y: 250 };
    const baseRadius = 125; // Reduced base radius to allow for more growth
    const maxDistortion = 0.5; // Increased max distortion for more dramatic changes

    let d = '';

    for (let i = 0; i <= points; i++) {
        const angle = i * angleStep;
        const freqIndex = Math.floor((i / points) * frequencies.length);
        const distortion = 1 + Math.min(frequencies[freqIndex] || 0, maxDistortion);
        
        // Use different frequency bands for x and y to create more irregularity
        const xDistortion = 1 + Math.min(frequencies[(freqIndex + 5) % frequencies.length] || 0, maxDistortion);
        const yDistortion = 1 + Math.min(frequencies[(freqIndex + 10) % frequencies.length] || 0, maxDistortion);

        const x = center.x + baseRadius * Math.cos(angle) * xDistortion;
        const y = center.y + baseRadius * Math.sin(angle) * yDistortion;

        if (i === 0) {
            d += `M${x},${y} `;
        } else {
            const prevAngle = (i - 1) * angleStep;
            const controlX = center.x + baseRadius * 1.5 * Math.cos((angle + prevAngle) / 2) * distortion;
            const controlY = center.y + baseRadius * 1.5 * Math.sin((angle + prevAngle) / 2) * distortion;
            d += `Q${controlX},${controlY} ${x},${y} `;
        }
    }

    return d + 'Z';
};

const path = computed(() => generatePath(props.frequencies));
</script>

<template>
    <div class="blob blur-md">
        <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            width="100%" id="blobSvg">
            <defs>
                <radialGradient id="gradient">
                    <stop offset="10%" :stop-color="`rgba(98, 18, 229, 0.6)`" />
                    <stop offset="100%" :stop-color="`rgba(98, 18, 229, 0.5)`" />
                </radialGradient>
            </defs>
            <path :d="path" fill="url(#gradient)" />
        </svg>
    </div>
</template>
